import { module } from 'modujs';
import gsap from 'gsap';

const logoCombinations = [1, 2, 3, 4];
const maxLogoCombinations = 8;
export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.$parent = this.$('parent')[0]
        this.$video = this.$('video')[0]
        this.$maskStripes = Array.from(this.$('mask-stripe'));
        this.$logo = this.$('logo')[0];

        if(window.isMobile) return;

        this.initTimeline()
    }

    // ==========================================================================
    // Timeline
    // ==========================================================================
    initTimeline() {
        this.timeline = gsap.timeline()

        this.timeline.addLabel('start');
        this.timeline.call(() => this.setCombination(1));

        this.timeline.fromTo(this.$video, { scale: 0.35, opacity: 0.5 }, { scale: 1.1, opacity: 1, duration: 1, ease: 'linear' }, 'start');

        this.$maskStripes.forEach((item, index) => {
            if(item.dataset.origin == "vertical") {
                this.timeline.fromTo(item, { scaleY: 0.9 }, { scaleY: 0, duration: 1, ease: 'linear' }, 'start');
            } else {
                this.timeline.fromTo(item, { scaleX: 0.9 }, { scaleX: 0, duration: 1, ease: 'linear' }, 'start');
            }
        })

        //logo
        this.timeline.call(() => this.setCombination(2), null, 'start+=0.05');
        this.timeline.call(() => this.setCombination(3), null, 'start+=0.1');
        this.timeline.call(() => this.setCombination(4), null, 'start+=0.15');
        this.timeline.call(() => this.setCombination(1), null, 'start+=0.2');
        this.timeline.call(() => this.setCombination(2), null, 'start+=0.25');
        this.timeline.call(() => this.setCombination(3), null, 'start+=0.3');
        this.timeline.call(() => this.setCombination(4), null, 'start+=0.35');
        this.timeline.call(() => this.setCombination(5), null, 'start+=0.4');
        this.timeline.call(() => this.setCombination(6), null, 'start+=0.45');
        // end
        this.timeline.call(() => this.setCombination(0), null, 'start+=0.5');

        this.timeline.pause();
        this.timeline.progress(0.1);
        this.timeline.progress(0);

        this.hasTimelineInit = true;
    }

    killTimeline() {
        this.timeline?.kill();
        gsap.set(this.$items, { clearProps: 'scale' });
        this.hasTimelineInit = false;
    }

    // ==========================================================================
    // Methods
    // ==========================================================================
    /**
     * Scroll event from `./Scroll.js`
     * @param {obj} scroll object
     */
    onScroll(obj) {
        if(window.isMobile || !this.hasTimelineInit) return;

        const progress = obj.currentElement.progress;

        this.update(progress);
    }

    /**
     * Update the timeline onScroll
     * @param {int} progress
     */
    update(progress) {
        this.timeline.progress(progress)
    }

    /**
     * Manage inview
     * @param {event} event
     */
    inview(event) {
        if(window.isMobile || !this.hasTimelineInit) return;

        if(event.way == 'exit' && event.obj.progress >= 1) {
            this.timeline.progress(1);
        }
    }

    setCombination(index) {
        this.$logo.dataset.combination = index
    }

    videoInview(e) {
        if(e.way === "enter") {
            if(this.$video.paused) {
                this.$video.play()
            }

        } else {
            if(!this.$video.paused) {
                this.$video.pause()
            }
        }
    }

    // ==========================================================================
    // Destroy
    // ==========================================================================
    destroy() {
        super.destroy()

        this.killTimeline()
    }
}
